import { ObjectResponseType } from '@pray/shared/utils/api/types/response';

import { CourseEpisode, GetEpisodesResponse } from './types';

export type GetEpisodesParams = {
  artistId: string;
  courseId: string;
};

// Episodes Mock Data
const getInitialEpisodes = (): CourseEpisode[] => [
  {
    id: '1',
    title: 'Introduction to Prayer',
    content: `<h1>Introduction to Prayer</h1>
    <p>Prayer is the foundation of our relationship with God. It is through prayer that we communicate with Him, expressing our gratitude, confessing our sins, and presenting our requests.</p>
    <h2>What We'll Learn</h2>
    <p>In this first episode, we'll explore the basics of prayer and why it's essential for spiritual growth. We'll discuss different types of prayer and how to establish a consistent prayer routine.</p>`,
  },
  {
    id: '2',
    title: 'Building a Prayer Habit',
    content: `<h1>Building a Prayer Habit</h1>
    <p>Consistency is key when it comes to developing a meaningful prayer life. In this episode, we'll discuss practical strategies for making prayer a daily habit.</p>
    <h2>Creating Sacred Space</h2>
    <p>Designating a specific time and place for prayer can help establish a routine.</p>`,
  },
  {
    id: '3',
    title: 'Overcoming Challenges in Prayer',
    content: `<h1>Overcoming Challenges in Prayer</h1>
    <p>Even the most devoted believers encounter obstacles in their prayer life. This episode addresses common challenges and how to overcome them.</p>`,
  },
];

/**
 * Get all episodes for a specific course
 * @param params - The parameters for fetching episodes
 * @param params.artistId - The ID of the artist
 * @param params.courseId - The ID of the course
 * @returns A promise that resolves to the episodes data
 */
export async function getEpisodes({ artistId, courseId }: GetEpisodesParams): Promise<GetEpisodesResponse> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!courseId) throw new Error('Course ID is required');

  await new Promise((resolve) => setTimeout(resolve, 800));

  const response: GetEpisodesResponse = {
    /* eslint-disable camelcase */
    responded_at: new Date().toISOString(),
    object: ObjectResponseType.OBJECT,
    data: getInitialEpisodes(),
    /* eslint-enable camelcase */
  };

  return response;

  // Uncomment when server implementation is ready
  // const url = `/web/artists/${artistId}/courses/${courseId}/episodes`;
  // const response = await api.executeGetRequest<GetEpisodesResponse>(url);
  // return response.data;
}
